export { default as UserAddSolidIcon } from './UserAddSolidIcon';
